import { useCallback } from 'react';
import { atom, useRecoilState } from 'recoil';
import { getPersistedValue, setPersistedValue } from '../../db/config';

const drawerState = atom({
  key: 'drawer',
  default: getPersistedValue('drawerOpen', false),
});

export function useDrawerState(): [boolean, (open: boolean) => void] {
  const [menuOpen, setMenuOpen] = useRecoilState(drawerState);
  const set = useCallback(
    (open: boolean) => {
      setMenuOpen(open);
      setPersistedValue('drawerOpen', open);
    },
    [setMenuOpen]
  );

  return [menuOpen, set];
}
